<template>
	<van-dialog
		class="home_patient_list"
		v-model="visible"
		title="切换档案"
		show-cancel-button
		confirmButtonText="确认切换"
		@confirm="clickSubmit"
	>
		<div v-if="list.length" class="home_patient_list_body">
			<base-list-item
				v-for="item in list"
				:key="item.id"
				:value="curPatientId === item.id"
				:type="curPatientId === item.id?'primary':''"
				:dot="!item.approveStatus"
				size="small"
				:user-name="item.name"
				:gender="$status.gender[item.gender]"
				:age="item.age"
				:tag="$status.relation[item.relation]"
				@click="() => curPatientId = item.id"
			/>
		</div>
		<van-empty v-else description="暂无档案" />
	</van-dialog>
</template>

<script>
export default {
    name: 'home-patient-list',
    data: () => ({
        visible: false,
        curPatientId: '',
        list: []
    }),
    methods: {
        init (id) {
            this.visible = true
            this.curPatientId = id
            this.getPatientList()
        },
        async getPatientList () {
            const res = await this.$api.patient.getPatientList()
            if (!res.code) {
                this.list = res.data
            }
        },
        clickSubmit () {
            this.$emit('clickSelect', { id: this.curPatientId, type: 'toggle' })
        }
    }
};
</script>

<style scoped lang="less">
.home_patient_list {
	.home_patient_list_body {
		padding: 40px;
		height: 450px;
		overflow-y: auto;
		> div + div {
			margin-top: 28px;
		}
	}
}
</style>
